import { getOgAdContext } from '../../../../../common/js/environment-utils';
import { RATIO } from '../../../../../common/js/ratio';

type StandardBannersSpecificRuleType = 'cover' | 'blur';

export const StandardBannersSpecificRule: {
  [key: string]: StandardBannersSpecificRuleType;
} = {
  COVER: 'cover',
  BLUR: 'blur'
};

const STANDARD_BANNERS_SPECIFIC_RULES: {
  [sizes: string]: { [ratio: string]: StandardBannersSpecificRuleType };
} = {
  '300x600': {
    [RATIO.VERTICAL]: StandardBannersSpecificRule.COVER
  },
  '320x480': {
    [RATIO.VERTICAL]: StandardBannersSpecificRule.COVER
  },
  '300x250': {
    [RATIO.RECTANGLE]: StandardBannersSpecificRule.COVER
  },
  '336x280': {
    [RATIO.RECTANGLE]: StandardBannersSpecificRule.COVER
  },
  '640x360': {
    [RATIO.RECTANGLE]: StandardBannersSpecificRule.BLUR
  }
};

export function GetStandardBannersSpecificRule(
  videoRatio: number
): StandardBannersSpecificRuleType | undefined {
  const formatSize = getOgAdContext().format_size_response || '';
  const rulesForSize = STANDARD_BANNERS_SPECIFIC_RULES[formatSize];

  if (!rulesForSize) return;
  return rulesForSize[videoRatio];
}
